import React, { useMemo } from 'react';
import EvalFilterChip from 'shared/components/filters/evals/EvalFilterChip';
import { useEvalLineages } from 'features/agent-analytics/components/EvalFilterSection';

/**
 * The eval conditions of a filter, as chips among the property chips.
 * `after` is how many chips come before them (the first chip says "where").
 */
export default function EvalChips({ teamId, lines, onChange, after = 0 }) {
  const lineages = useEvalLineages(teamId);
  const names = useMemo(() => Object.fromEntries((lineages || []).map((l) => [l.id, l.name])), [lineages]);
  const list = Array.isArray(lines) ? lines : [];
  if (!list.length) return null;
  return list.map((line, i) => (
    <EvalFilterChip key={line.key} teamId={teamId} line={line} evalName={line.lineage_id ? names[line.lineage_id] : 'Any eval'}
      isFirst={after + i === 0}
      onChange={(next) => onChange(list.map((x) => (x.key === line.key ? next : x)))}
      onRemove={() => onChange(list.filter((x) => x.key !== line.key))} />
  ));
}
